/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import HeroCover from '../../../../../../src/asset/images/iStock-1361215711.png';
import YoutubeIcon from '../../../../../../src/asset/images/youtube_icon.svg';
import ChevronIcon from '../../../../../../src/asset/images/right_chevron.svg';
import FeedbackIcon from '../../../../../../src/asset/images/feedback_icon.svg';
//import { breakPoint_L } from '../../../../../utility/breakPoints';
//import { constants } from '../../../../../utility/constants';
import { withTranslation } from 'react-i18next';
//import YouTubeModal from '../../../youTubeModal';
import { YOUTUBE_LINKS, FEED_BACK_FORMS } from '../../../../../api/api-config';
import { getBreakpoint } from '../../../../../selectors/commonSelectors';
import { windowOpenHandler } from '../../../../../utility/common';


class BannerImage extends Component {
  constructor (props) {
    super(props);
    this.howToUse = this.howToUse.bind(this);
    this.powerUserFeedBackForm = this.powerUserFeedBackForm.bind(this);
    this.endUserFeedBackForm = this.endUserFeedBackForm.bind(this);
    this.goToLogin = this.goToLogin.bind(this);
    this.state = {
      showModal: false,
    };
  }

  howToUse () {
    //this.props.history.push(YOUTUBE_LINKS.how_to_use_visava_english);
    const langCode = localStorage.getItem('lang');
    if( langCode === 'en') {
      windowOpenHandler(YOUTUBE_LINKS.how_to_use_visava_english);
    } else {
      windowOpenHandler(YOUTUBE_LINKS.how_to_use_visava_hindi);
    }
  }

  powerUserFeedBackForm () {
    windowOpenHandler(FEED_BACK_FORMS.power_user_form);
  }

  endUserFeedBackForm () {
    windowOpenHandler(FEED_BACK_FORMS.end_user_form);
  }

  goToLogin () {
    const { history } = this.props;
    if (history) {
      history.push('/login');
    }
  }

  render () {
    const { breakpoint, t }= this.props;
    return (
      <div className='banner-container-top'>
        <div className='join_community_strip'
          onClick={this.powerUserFeedBackForm}>
          {t('feedback_title')}
          <img src={ChevronIcon} />
        </div>
        <div className='feedback_btn'
          onClick={this.endUserFeedBackForm}>
          <img src={FeedbackIcon} />
          <span className='lbl'>{t('share_feedback')}</span>
        </div>
        <div
          id='dashboardImage'
          className='dashboardImageContainer'>
          <img
            className='heroBackgroundImage'
            src={HeroCover}
            alt={t('first_tech')}
            decoding='async' />
          <div className='dashboardImageLink'
            // onClick={() => this.setState({ showModal: true })}
            onClick={this.howToUse}>
            <img className='youtubeIcon'
              src={YoutubeIcon}
              alt='' />
            {breakpoint == 'lg' && <div className='how-to-use'
              onClick={this.howToUse}>{t('how_to_use')}</div>}
          </div>
          {/* Legacy desktop card (finger_tips + Google Play + QR) was PlayStore in googlePlayContainer; kept in ../playstoreWrapper for reuse. */}
          <div className='heroIntro'>
            <div className='heroIntroCard'>
              <p className='heroIntroTagline'>{t('first_tech')}</p>
            </div>
            <button
              type='button'
              className='heroIntroCta visava-btn'
              onClick={this.goToLogin}>
              {t('get_started_free')}
            </button>
          </div>
        </div>
        {/* {this.state.showModal ? (
          <YouTubeModal
            shown={this.state.showModal}
            close={() =>
              this.setState({
                showModal: false,
              })
            }
            youTubeLink={YOUTUBE_LINKS.how_to_use} />
        ) : null} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  breakpoint : getBreakpoint(state)
});

BannerImage.propTypes = {
  history : PropTypes.shape({
    push : PropTypes.func.isRequired,
  }).isRequired,
  breakpoint : PropTypes.string.isRequired,
  t : PropTypes.func.isRequired,
};

export default withRouter(withTranslation()(connect(mapStateToProps, null)(BannerImage)));
